<template>
  <div id="glossary">

    <md-card>
      <md-card-header>
        <div class="md-title">はじめに</div>
        <!-- <div class="md-subhead">Subtitle here</div> -->
      </md-card-header>

      <md-card-content>
        <h3>セットダンスとは</h3>
        <span class="md-body-1">セットダンスとは二人一組のカップルを4組集めて8人で踊るアイルランドのダンスです。</span>

        <h3>セットについて</h3>
        <span class="md-body-1">セット（Set）とはフィガーの集まりです。フィガー（Figure）とはダンスの位置動作の連なりです。一つのフィガーはおよそ100~200小節の動きで構成されています。一つのセットは3~7個ほどのフィガーから構成されています。
        日本のケーリーでよく踊られているセットには「Caledonian Set」「Plain Set」「Clare Lancers Set」などがあります。後述するカップルの集まりであるセット(Set)も英語ですと同じ綴りですが別の意味を指します。</span>

        <h3>カップルについて</h3>
        <span class="md-body-1">各カップルは正方形状に内側を向くようにして並びます。このときジェント（男性）はレディーの左側、レディー（女性）
        はジェントの右側になるように並びます。1セットは4組のカップルで構成され、伴奏するバンドを背にしたカップルを「1st Top」、
        1st Top と向き合っている（バンドに対して向き合っている）カップルを「2nd Top」と呼びます。1st Top から見て左側のカップルを「1st Side」。
        1st Top から見て右側のカップルを「2nd Side」と呼びますが、踊るセットによっては 1st Side と 2nd Side が逆転することもあります。
        1st Top と 2nd Top を合わせて「Tops」、1st Side と 2nd Side を合わせて「Sides」と呼ぶこともあります。
        </span>
      </md-card-content>

      <!-- <md-card-actions>
        <md-button>Action</md-button>
        <md-button>Action</md-button>
      </md-card-actions> -->
    </md-card>

    <md-card>
      <md-card-header>
        <div class="md-title">よくある動き</div>
      </md-card-header>

      <md-card-content>
        <h3>Advance & Retire (A.R.)</h3>
        <span class="md-body-1">各カップルのジェントとレディーは自分のパートナと右手と左手、左手と右手で手を繋ぐ。中央に向かって時計回りに90度向きを変えた状態で 8 bar かけて前のカップルを追いかけるようにして1周する。</span>
        <h3>Home</h3>
        <h3>House</h3>
        <h3>Ladies Chain (L.C.)</h3>
        <h3>Lead Around (L.A.)</h3>
        <h3>Little Christmas</h3>
        <h3>cross hand</h3>
        <h3>walz hold</h3>
        <h3>kerry hold</h3>
        <h3>Swing</h3>
      </md-card-content>

    </md-card>

    <!-- <md-divider></md-divider>

    <span class="md-caption">copyright © 2017 Hiroshi Jo</span> -->

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// Intro.vue?b63443ae